import z from 'zod';
import { groupExistsCheck } from '../../../api/users-api';
import { emailRegex } from '../../../utils/regular-expressions';

export const DirectoryGroupSchema = z.object({
  id: z.string().optional(),
  email: z.string().min(1, 'Email is required.'),
  name: z.string().min(1, 'Name is required.'),
  description: z.string(),
  adminCreated: z.boolean().optional(),
  aliases: z.array(z.string()).optional(),
  nonEditableAliases: z.array(z.string()).optional(),
  directMembersCount: z.number().optional(),
  groupTemplate: z.number().nullable(),
  labels: z.record(z.string(), z.boolean()),
});

export function getGroupFormSchema(domain: string) {
  return DirectoryGroupSchema.superRefine((data, ctx) => {
    const userEmail = `${data.email}@${domain}`;
    if (!data.email) return;
    if (!emailRegex.test(userEmail)) {
      ctx.addIssue({
        code: 'custom',
        message: `${userEmail} is not a valid email address.`,
        path: ['email'],
      });
      return;
    }
  }).superRefine(async (data, ctx) => {
    const userEmail = `${data.email}@${domain}`;
    if (!data.email) return;
    try {
      const userExists = await groupExistsCheck(userEmail);
      if (userExists) {
        ctx.addIssue({
          code: 'custom',
          message: 'Group already exists.',
          path: ['email'],
        });
      }
    } catch (error) {
      console.error('Group existence check failed:', error);
      ctx.addIssue({
        code: 'custom',
        message: 'Could not verify email. Please try again.',
        path: ['email'],
      });
    }
  });
}

export type DirectoryGroupFormValues = z.infer<typeof DirectoryGroupSchema>;
